module.exports = __webpack_public_path__ + "fonts/bebas-neue-bold.1a15f389.ttf";